import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_5yoaobuy2a: FaireBrandEntity = {
  token: "b_5yoaobuy2a",
  type: "brand",
  name: "Naturacentric",
  avatarUrl:
    "https://cdn.faire.com/fastly/2bcfca518ef4640afc6c597ef6ce3f30ca3822ea32d6b93a650855f8038f3c6f.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/c1b7ec7c43bf5f90ffa631a16e1dd2ee7c00599e3ff5db7a0d9e9e47a038574b.png",
  logoUrl:
    "https://cdn.faire.com/fastly/2bcfca518ef4640afc6c597ef6ce3f30ca3822ea32d6b93a650855f8038f3c6f.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/c1b7ec7c43bf5f90ffa631a16e1dd2ee7c00599e3ff5db7a0d9e9e47a038574b.png",
  location: "Modesto, CA, USA",
  minimumOrderDollars: 208,
  rating: 5,
  reviewCount: 81,
  isTopShop: true,
  isInsider: true,
  description:
    'Naturacentric is an eco-friendly lifestyle brand that empowers you to live holistically. We specialize in a unique line of herbal infused local raw honey that includes: Hibiscus, Elderberry, Ginger, Ghost Pepper, Rose Cardamom, Mission Fig, Vanilla Cinnamon, Cacao and many others. \n\nWe also specialize in Elderberry Wellness Elixir. This is like an Elderberry syrup but far more potent with herbs like Astragalus root, Reishi Mushroom, Nettles, Mullein, Echinacea and many other restorative herbs. Think of it as a supercharged version! \n\nWe have a noteworthy line of loose leaf teas targeting specific aliments such as our "Anti- inflammatory" blend, "Calm Stomach", and "Endometriosis Support". \n\nOur Essential oil based bath products, hand sanitizers, all purpose house sprays, and bug repellant are all natural and catered toward skin sensitivities, making these a healthier alternative than other brands on the market. \n\nWe work with local beekeepers and farmers to source fresh natural organic ingredients. We at naturacentric take everyday items and create a more healthier sustainable alternative. \n',
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:06:16.942Z",
    importedBy: "entity-db-cli",
  },
};
